import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Modal, Tooltip, Typography, CircularProgress } from '@mui/material'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Icon from '@mui/material/Icon'
import { useStyles } from '../Pathologist/inboxStyles'
import PatientCaseHistory from '../Common/PatientCaseHistoryModal'
import { InProgressColumns } from './table_def'
import { getInProgressData, unassignCase } from '../../../actions'
import { RootState } from '../../../reducers'
import { CaseStatus } from './../../../utils/displayLabels'
import TransferCaseModal from '../LabManager/TransferCaseModal'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import GroupRemoveOutlinedIcon from '@mui/icons-material/GroupRemoveOutlined'
import DeleteDialog from '../../HOC/DeleteDialog'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { clearPremerisApiCache, clearPremerisReportApiCache, setCaseData, refreshCaseData } from '../../../actions'
import LaunchPremeris from '../../CaseDiagnosis/LaunchPremeris'
import CustomDatagridDateRangeFilter from '../Common/CustomDatagridDateRangeFilter'
import { DataGrid, getGridStringOperators, GridFilterItem, GridFilterModel, GridFilterOperator } from '@mui/x-data-grid'
import CustomDatagridDropDownFilter from '../Common/CustomDatagridDropDownFilter'

interface userObj {
  id?: number
  case_id?: number
  user_id?: string
  slide_status_id?: number
}

function InProgress({ userId }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const inProgresssData = useSelector((state: RootState) => state.getInProgressData)
  const [userDetails, setUserDetails] = useState<userObj>({})
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)
  const { workflowId } = useSelector((state: RootState) => state.getCaseData)
  const refreshData = useSelector((state: RootState) => state.refreshCase)
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [resetAssignmentOpen, setResetAssignmentOpen] = useState(false)
  const gridPageSize = 10
  const totalCount = inProgresssData.total_count
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [pageValue, setPageValue] = useState(0)
  const [isFirstPage, setFirstPage] = useState(false)
  const [premerisOpen, setPremerisOpen] = useState(false)
  const [isReadOnlyMode, setReadOnlyMode] = useState(false)
  const [findUrl, setFindUrl] = useState('')
  const { re_unassignCase_success, re_unassignCase_error } = useSelector((state: RootState) => state.unassignResponse)
  const [filterValue, setFilterValue] = useState('')
  const [filterName, setFilterName] = useState('created_datetime')
  const [sortField, setSortField] = useState('case_number')
  const [sortOrder, setSortOrder] = useState('asc')
  const [isFilter, setFilter] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [columnModel, setColumnModel] = useState('created_datetime')
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
      {
        id: 1,
        columnField: 'quantity',
        value: [5000, 15000],
        operatorValue: 'between',
      },
    ],
  })

  const displayInProgresssData = inProgresssData?.data?.filter((val) => {
    val.index = val.case_number
    return val
  })

  const ProcedureCodeRenderer = {
    field: 'procedure_code',
    headerName: 'Case Type',
    sortable: true,
    width: 200,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    valueGetter: (params) => {
      const procedureCodeResults = procedureData.procedureCodeMap.filter((value) => {
        return value.id == params.row.procedure_code
      })
      return procedureCodeResults[0]?.display
    },
  }

  const CaseStatusRenderer = {
    field: 'workflow_stage_id',
    headerName: 'Case Status',
    width: 200,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    sortable: true,
    renderCell: (params) => {
      const caseStatus = CaseStatus(params.row.stage_id, role, display_labels)
      const statusArray = caseStatus.labelStr.split(', ')
      const style = { backgroundColor: caseStatus.labelColor }
      return (
        <>
          {statusArray.map((caseStatus) => (
            // eslint-disable-next-line react/jsx-key
            <>
              <Tooltip title={caseStatus} placement="top-start">
                <Stack direction="row" spacing={2}>
                  <Chip className={classes.chipSpacing} color="primary" style={style} label={caseStatus} />
                </Stack>
              </Tooltip>
            </>
          ))}
        </>
      )
    },
  }

  const InprogressIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 148,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    filterable: false,
    sortable: false,
    renderCell: (params) => {
      const disableTransferStages = [
        'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
        'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
        'AMEND_RESULTED_RESULT_RELEASED',
        'CORRECT_RESULTED_2HRWINDOW',
        'CORRECT_RESULTED_RESULT_RELEASED',
      ]
      const unassignTransferStages = [
        'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
        'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
        'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
        'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT',
      ]
      return (
        <>
          <Tooltip title="Case details" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
          {params.row.stage_id !== 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' &&
            disableTransferStages.includes(params.row.stage_id) === false && (
              <>
                &nbsp;&nbsp;&nbsp;
                <Tooltip title="Transfer case" placement="top-start">
                  <PeopleAltOutlinedIcon onClick={(event) => handleTransferModalOpen(event, params.row)}>
                    Transfer
                  </PeopleAltOutlinedIcon>
                </Tooltip>
              </>
            )}

          {unassignTransferStages.includes(params.row.stage_id) && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Unassign case" placement="top-start">
                <GroupRemoveOutlinedIcon onClick={(event) => handleResetAssignmentOpen(event, params.row)}>
                  Unassign case
                </GroupRemoveOutlinedIcon>
              </Tooltip>
            </>
          )}
        </>
      )
    },
  }

  const handleFilter = useCallback(
    (obj) => {
      setFilter(true)
      setFilterName(obj.filterField)
      setFilterValue(obj.filterValue)
      setStartDate(obj.startDate)
      setEndDate(obj.endDate)
      setSortField(obj.sortField ? obj.sortField : 'case_number')
    },
    [isFilter],
  )

  const quantityOnlyOperators: GridFilterOperator[] = [
    {
      label: 'Between',
      value: 'between',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDateRangeFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'in_progress' },
    },
  ]

  const dropdownOnlyOperators: GridFilterOperator[] = [
    {
      label: 'List',
      value: 'list',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDropDownFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'in_progress' },
    },
  ]

  const ColumnsCustomFilters = (columnsData: any) => {
    const newInProgressColumns = [...columnsData]

    if (newInProgressColumns.length > 0) {
      const assignedDateIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Assigned On')
      const assignedIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Assign By')
      const caseTypeIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Case Type')
      const priorityIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Priority')
      const workflowIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Case Status')
      const assignedToIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Assigned To')
      const statesIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Location')
      const patientNameIndex = newInProgressColumns.findIndex((col) => col.headerName === 'Patient Name')
      const trfIdIndex = newInProgressColumns.findIndex((col) => col.headerName === 'TRF ID')

      if (assignedDateIndex !== -1) {
        newInProgressColumns[assignedDateIndex] = {
          ...newInProgressColumns[assignedDateIndex],
          filterOperators: quantityOnlyOperators,
        }
      }
      if (assignedIndex !== -1) {
        newInProgressColumns[assignedIndex] = {
          ...newInProgressColumns[assignedIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (statesIndex !== -1) {
        newInProgressColumns[statesIndex] = {
          ...newInProgressColumns[statesIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (assignedToIndex !== -1) {
        newInProgressColumns[assignedToIndex] = {
          ...newInProgressColumns[assignedToIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (caseTypeIndex !== -1) {
        newInProgressColumns[caseTypeIndex] = {
          ...newInProgressColumns[caseTypeIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (priorityIndex !== -1) {
        newInProgressColumns[priorityIndex] = {
          ...newInProgressColumns[priorityIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (workflowIndex !== -1) {
        newInProgressColumns[workflowIndex] = {
          ...newInProgressColumns[workflowIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (patientNameIndex !== -1) {
        newInProgressColumns[patientNameIndex] = {
          ...newInProgressColumns[patientNameIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
        }
      }
      if (trfIdIndex !== -1) {
        newInProgressColumns[trfIdIndex] = {
          ...newInProgressColumns[trfIdIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'startsWith'),
        }
      }
    }

    return newInProgressColumns
  }

  InProgressColumns.push(ProcedureCodeRenderer)
  InProgressColumns.push(CaseStatusRenderer)
  InProgressColumns.push(InprogressIconRender)

  const handleOpen = (event, rowData: any) => {
    setUserDetails(rowData)
    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  const handleTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setTransferModalOpen(true)
  }

  const handleTransferModalClose = () => setTransferModalOpen(false)

  const handleResetAssignmentOpen = (event, row: any) => {
    setUserDetails(row)
    setResetAssignmentOpen(true)
  }

  const handleResetAssignmentClose = () => setResetAssignmentOpen(false)

  const handlePageChange = (page, details) => {
    dispatch(
      getInProgressData({
        id: `${userId}`,
        pageIndex: page + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : columnModel,
        filterValue: filterValue,
        caseView: 'in_progress',
        startDate: startDate,
        endDate: endDate,
        sortOrder: sortOrder,
        sortField: sortField,
      }),
    )
  }

  const handleSubmit = async () => {
    await dispatch(unassignCase({ caseid: userDetails.case_id, currentid: userDetails.user_id, userid: userId }))
    setOpenSuccessSnackBar(true)
    setFirstPage(true)
    setTimeout(updateDataTable, 1500)
  }

  const updateDataTable = async () => {
    await dispatch(
      getInProgressData({
        id: `${userDetails.user_id}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'in_progress',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: 'created_datetime',
      }),
    )
    handleResetAssignmentClose()
  }

  const handlePremerisOpen = async (event, caseId: any, data) => {
    const filterAssignedResults = data.filter((value) => {
      return value.case_id == caseId
    })
    const patientName = `${filterAssignedResults[0].patient_last_name || ''}, ${
      filterAssignedResults[0].patient_first_name || ''
    }`
    setLoading(true)
    await handleRefreshCases(filterAssignedResults[0].case_number + '000')
    dispatch(
      setCaseData({
        pathologist: { first_name: filterAssignedResults[0].first_name, last_name: filterAssignedResults[0].last_name },
        pathologistId: filterAssignedResults[0].user_id,
        caseNumber: filterAssignedResults[0].case_number,
        procedureCodeId: filterAssignedResults[0].procedure_code,
        workflowId: filterAssignedResults[0].stage_id,
        patientName: patientName,
        caseId: caseId,
        nlOrderId: filterAssignedResults[0].nl_order_id,
        userCaseWorkflowId: filterAssignedResults[0].id,
        slideStatusId: filterAssignedResults[0].slide_status_id,
        mcFlag: filterAssignedResults[0].mc_flag,
        statFlag: filterAssignedResults[0].stat_flag,
      }),
    )
    setLoading(false)
    setPremerisOpen(true)
  }

  const handleRefreshCases = async (trfBarcode) => {
    await dispatch(refreshCaseData({ trfBarcode: trfBarcode }))
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
  }

  const handlePremerisClose = async () => {
    updateTrfStartDataTable()
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
    setPremerisOpen(false)
  }

  const updateTrfStartDataTable = async () => {
    dispatch(
      getInProgressData({
        id: `${userId}`,
        pageIndex: pageValue + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'in_progress',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
  }

  const onFilterChange = async (model: GridFilterModel) => {
    setFilterName('')
    setFilterValue('')
    setStartDate('')
    setEndDate('')
    setFilterModel(model)
    if (model.items.length && model.items[0].value) {
      await onFilterApply(model)
    } else {
      await clearFilter()
      setFilter(false)
    }
  }

  const clearFilter = async () => {
    //const apiRef = useGridApiContext();
    await dispatch(
      getInProgressData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: null,
        caseView: 'in_progress',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: 'created_datetime',
      }),
    )
    //apiRef.current.hideFilterPanel()
  }
  const onFilterApply = React.useCallback(async (model: GridFilterModel) => {
    if (model.items.length) {
      if (
        (model.items[0].columnField === 'patient_first_name' || model.items[0].columnField === 'case_number') &&
        model.items[0].value &&
        model.items[0].value.length
      ) {
        const val = model.items[0].value
        setFilterValue(val)
        const name = model.items[0].columnField
        setFilterName(name)
        await dispatch(
          getInProgressData({
            id: userId,
            caseView: 'in_progress',
            filterField: model.items[0].columnField,
            filterValue: val,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: 'created_datetime',
          }),
        )
        setFilter(true)
      }
    }
  }, [])

  const handleFilteredPageChange = async (page: any, details: any) => {
    setSortOrder(details[0].sort)

    await dispatch(
      getInProgressData({
        id: `${userId}`,
        caseView: 'in_progress',
        filterField: filterName !== '' ? filterName : details[0].field,
        filterValue: filterValue,
        startDate: startDate,
        endDate: endDate,
        sortOrder: details[0].sort ? details[0].sort : 'asc',
        pageIndex: page + 1,
        pageSize: gridPageSize,
        sortField: details[0].field,
      }),
    )
  }

  return (
    <div className={classes.container}>
      <Modal
        open={refreshData && refreshData.fetchInProgress}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <CircularProgress style={{ marginLeft: '45%', marginTop: '40vh', position: 'absolute', color: '#0A688D' }} />
          <Typography
            style={{
              fontWeight: 'bolder',
              color: 'rgba(255,255,255,0.8)',
              fontSize: 'larger',
              marginLeft: '35%',
              marginTop: '47vh',
              position: 'absolute',
            }}
          >
            Refreshing the case details from LabOS...
          </Typography>
        </div>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <PatientCaseHistory userDetails={userDetails} handleClose={handleClose} />
        </Box>
      </Modal>
      <TransferCaseModal
        open={transferModalOpen}
        userId={userId}
        isSearch={false}
        trfId={null}
        onClose={handleTransferModalClose}
        userDetails={userDetails}
        setFirstPage={setFirstPage}
        filterName={filterName}
        filterValue={filterValue}
        sortField={sortField}
        startDate={endDate}
        endDate={endDate}
      />
      {openSuccessSnackBar && re_unassignCase_success && <SuccessSnackBar message="Successfully unassigned the case" />}
      {openSuccessSnackBar && re_unassignCase_error && <ErrorSnackBar message="Unable to unassign the case" />}
      {resetAssignmentOpen && (
        <DeleteDialog
          header="Unassign"
          open={resetAssignmentOpen}
          onClose={handleResetAssignmentClose}
          handleSubmit={handleSubmit}
        />
      )}
      <div className={classes.mt}>
        <Box
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d688d73',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: 'transparent !important',
            },
            '& .MuiDataGrid-cell:hover': {
              cursor: 'pointer !important',
            },
            '& .MuiDataGrid-filterForm': { p: 2 },
          }}
        >
          {display_labels && displayInProgresssData && (
            <DataGrid
              disableColumnSelector
              autoHeight
              pagination
              pageSize={10}
              paginationMode="server"
              rowCount={totalCount}
              rows={displayInProgresssData}
              columns={ColumnsCustomFilters(InProgressColumns)}
              page={isFirstPage ? 0 : pageValue}
              loading={inProgresssData.fetchInProgress}
              onPageChange={(page, details) => {
                setPageValue(page)
                setFirstPage(false)
                handlePageChange(page, details)
              }}
              filterModel={filterModel}
              onFilterModelChange={(model) => onFilterChange(model)}
              componentsProps={{
                filterPanel: {
                  filterFormProps: {
                    // Customize inputs by passing props
                    columnInputProps: {
                      variant: 'outlined',
                      size: 'small',
                      sx: { mt: 'auto' },
                    },
                    operatorInputProps: {
                      variant: 'outlined',
                      size: 'small',
                      sx: { mt: 'auto' },
                    },
                    valueInputProps: {
                      required: true,
                    },
                  },
                  sx: {
                    // Customize inputs using css selectors
                    '& .MuiDataGrid-filterForm': {
                      p: 2,
                      display: 'block',
                      width: 'fit-content',
                      justifyContent: 'flex-start',
                    },
                    '& .MuiDataGrid-filterForm:nth-child(even)': {},
                    '& .MuiDataGrid-filterFormLinkOperatorInput': { mr: 2 },
                    '& .MuiDataGrid-filterFormColumnInput': { mr: 2, width: 150 },
                    '& .MuiDataGrid-filterFormOperatorInput': { mr: 2 },
                    '& .MuiDataGrid-filterFormValueInput': { width: 'fit-content' },
                  },
                },
                panel: {
                  sx: {
                    '& .MuiDataGrid-panelWrapper': { overflow: 'visible' },
                    '& .MuiDataGrid-panelContent': { overflow: 'visible', display: 'flex' },
                    '& .MuiFormControl-root': {
                      width: 'auto',
                      minWidth: '55px',
                      marginRight: '18px',
                      justifyContent: 'end',
                    },
                  },
                },
              }}
              onSortModelChange={(newSortModel) => {
                if (newSortModel.length) setSortField(newSortModel[0].field)
                setPageValue(0)
                handleFilteredPageChange(pageValue, newSortModel)
              }}
              onCellClick={(params, event) => {
                event.defaultMuiPrevented = true
                if (params.field === '') {
                  return
                } else {
                  setReadOnlyMode(true)
                  handlePremerisOpen(event, params.row.case_id, displayInProgresssData)
                }
              }}
            />
          )}
        </Box>
        <Modal
          open={premerisOpen}
          onClose={handlePremerisClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <LaunchPremeris
            caseView={'in_progress'}
            urlLink={findUrl}
            handlePremerisClose={handlePremerisClose}
            handleTRFComplete={null}
            isReadOnlyMode={isReadOnlyMode}
            isAmendFlow={false}
          />
        </Modal>
      </div>
    </div>
  )
}

export default InProgress
